export class Strings {
  public static normalize(str: string): string {
    return (
      this.unaccent(str)
        // make lowercase string
        .toLowerCase()
        // removes any leading and trailing characters
        .trim()
        // replace two or more spaces with a single space
        .replace(/  +/g, " ")
    );
  }

  public static unaccent(str: string): string {
    return (
      str
        .normalize("NFD")
        // replace accents
        .replace(/[\u0300-\u036f]/g, "")
    );
  }

  public static titlecase(str: string): string {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }
}
